module.exports = __webpack_public_path__ + "static/media/eco_logo_popup.fe87947d.svg";